import { rootAPI } from '../../config/api';

export const FETCH_INSTRUCTION_DATA_REQUEST = 'FETCH_INSTRUCTION_DATA_REQUEST';
export const FETCH_INSTRUCTION_DATA_SUCCESS = 'FETCH_INSTRUCTION_DATA_SUCCESS';
export const FETCH_INSTRUCTION_DATA_FAILURE = 'FETCH_INSTRUCTION_DATA_FAILURE';

export const fetchSystemInstructionByAppRequest = () => ({
  type: FETCH_INSTRUCTION_DATA_REQUEST,
});

export const fetchSystemInstructionByAppSuccess = (data) => ({
  type: FETCH_INSTRUCTION_DATA_SUCCESS,
  payload: data,
});

export const fetchSystemInstructionByAppFailed = (error) => ({
  type: FETCH_INSTRUCTION_DATA_FAILURE,
  payload: error,
});

export const fetchSystemInstructionByAppId = (appId, instructionType) => {
  return async (dispatch) => {
    dispatch(fetchSystemInstructionByAppRequest());
    try {
      const url = `${rootAPI}/api/basic/v1/system/propmt/default/${appId}?instructionType=${instructionType}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // Authorization: `Basic ${your_token}`, 
        },
      });
      
      const data = await response.json();
      
      if (response.ok) {
        dispatch(fetchSystemInstructionByAppSuccess(data.instruction || {}));
      } else {
        dispatch(fetchSystemInstructionByAppFailed(data.message || 'Failed to fetch'));
      }
    } catch (error) {
      dispatch(fetchSystemInstructionByAppFailed(error.message));
    }
  };
};
